import styled, { css } from 'styled-components';
import ConfirmButton from '../../../components/ConfirmButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faHandshake,
  faHandshakeSlash,
  faShare,

} from '@fortawesome/free-solid-svg-icons';

const shareGroupCss = css`
display: flex;
gap: 10px;
align-items: center;
`
const ShareWithGroup = styled(({ className, list, group, onShare, onUnshare, onSetCollaborate}) => {
  return (
    <div className={className}>
      {group.isShared
        ?<>
          <ConfirmButton
            text={`Do you want to remove the list "${list.name}" from "${group.name}"?`}
            confirm='Yes'
            cancel='No'
            className='danger'
            onConfirm={() => onUnshare({ groupId: group._id })}
            onCancel={() => {}}>
            X
          </ConfirmButton>
          {group.isCollaborating 
            ?<ConfirmButton
              text={`Do you want "${group.name}" to stop collaborating on ${list.name} ?`}
              confirm='Yes'
              cancel='No'
              className='danger'
              onConfirm={() => onSetCollaborate({ groupId: group._id }, false)}
              onCancel={() => {}}>
              <FontAwesomeIcon icon = {faHandshakeSlash}/>
            </ConfirmButton>
            : <ConfirmButton
              text={`Do you want to allow this group to collaborate on "${list.name}"?`}
              confirm='Yes'
              cancel='No'
              className='primary'
              onConfirm={() => onSetCollaborate({ groupId: group._id }, true)}
              onCancel={() => {}}>
              <FontAwesomeIcon icon = {faHandshake} />
            </ConfirmButton>
          }
        </>
        : <ConfirmButton
          text={`Do you want share the list "${list.name}" with "${group.name}"?`}
          confirm='Yes'
          cancel='No'
          className='primary'
          onConfirm={() => onShare({ groupId: group._id })}
          onCancel={() => {}}>
          <FontAwesomeIcon icon = {faShare} />
        </ConfirmButton>
      }
      <div>{group.name}</div>
    </div>
  )
})`${shareGroupCss}`;

export default ShareWithGroup;